import PeriodicWorkflowDetail from '@/features/Workflow/WorkflowDetail/periodic/PeriodicWorkflowDetail';

const CreatePeriodicNotificationPage = () => {
  return <PeriodicWorkflowDetail mode="CREATE" />;
};

export default CreatePeriodicNotificationPage;
